import { List, ListItem, ListItemText, Stack } from "@mui/material";
import CustomMenu from "../../../../../../components/Menu";
import Loader from "../../../../../../components/Loader";
import Avatar from "../../../../../../components/Avatar";
import { hasImage } from "../../../../../../utils/helpers";
import GetHeadShotName from "../../../../../../utils/getHeadShotName";
import { CustomTextField } from "../../../../../../components/TextField";
import React, { useEffect, useState, useRef } from "react";

export default function MentionList({
  mentionListVisible,
  anchorEl,
  elementPos,
  handleMentionClose,
  isLoading,
  handleChange,
  selectedUserForTag,
  handleUserSelect,
}) {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const listRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    itemRefs.current = itemRefs.current.slice(0, selectedUserForTag?.length || 0);
  }, [selectedUserForTag]);

  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [selectedIndex]);

  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, selectedUserForTag.length - 1));
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (event.key === "Enter") {
      event.preventDefault();
      if (selectedIndex >= 0) {
        handleUserSelect(selectedUserForTag[selectedIndex]);
      }
    }
  };

  useEffect(() => {
    // Reset selected index when the mention list is closed
    if (!mentionListVisible) {
      setSelectedIndex(-1);
    }
  }, [mentionListVisible]);

  return (
    <CustomMenu
      open={mentionListVisible}
      anchorEl={anchorEl}
      className="tag-user-list"
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      isApplyCustomMenuCss={false}
      sx={{
        "& .MuiPaper-root": {
          top: `${elementPos?.top}px !important`,
          left: `${elementPos?.left}px !important`,
          minWidth: "258px",
        },
      }}
      onClose={handleMentionClose}
      onKeyDown={handleKeyDown}
    >
      {!isLoading && (
        <Stack alignItems={"center"} mx={1}>
          <CustomTextField
            placeholder="search..."
            fullWidth
            autoFocus
            onChange={handleChange}
            sx={{
              "& .MuiInputBase-input": {
                padding: "8px 10px",
              },
            }}
          />
        </Stack>
      )}
      <List
        ref={listRef}
        sx={{
          maxHeight: "200px",
          overflow: "auto",
          paddingTop: "0px !important",
        }}>
          {isLoading ? (
            <ListItem className="justify-content-center align-items-center">
              <Loader color={"black"} />
            </ListItem>
          ) : selectedUserForTag?.length > 0 ? (
            selectedUserForTag?.map((user, index) => (
              <ListItem
                button
                key={`mention-user-item-${user?.id}`}
                onClick={() => handleUserSelect(user)}
                selected={selectedIndex === index}
                ref={el => itemRefs.current[index] = el}
              >
                <Avatar
                  title={`${user?.username}`}
                  user_image={user?.user_image}
                  className="user-avatar"
                  style={
                    !hasImage(user?.user_image) && {
                      bgcolor: user?.profile_color?.background,
                      color: user?.profile_color?.text,
                    }
                  }>
                  {GetHeadShotName(user?.username)}
                </Avatar>
                <ListItemText
                  sx={{ marginLeft: "8px" }}
                  primary={user?.username}
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText
                primary="No User found"
                sx={{ textAlign: "center" }}
              />
            </ListItem>
          )}
        </List>
    </CustomMenu>
  );
}
